export default __webpack_public_path__ + "static/media/main_yacht.c91fbf0e.jpg";